import React from 'react';

const Empty = () => {
  return (
    <section 
      // style={{
      //   back: white;
      //   height: 100%;
      //   border-radius: 15px;
      // }}>
      style={{
        background: '#FFF',
        height: '100%',
        borderRadius: '15px'
      }}
      >
    </section>
  )
}

export default Empty;